<!-- christmas logo -->
<img
    src="../../../assets/svg/christmasLogo.svg"
    *ngIf="theme === 'xmas'"
    alt="christmas logo viatim"
/>

<!-- Normal Viatim Logo -->
<img src="../../../assets/svg/logoVA.svg" *ngIf="theme === 'normal'" alt="logo viatim" />
